import React, { useContext, useState } from 'react';
import './StepThreeComponent.scss';
import { AppContext } from '../../App';
import { downloadCode, emailCode } from '../../network/ApiService';

const StepThreeComponent = ({ isOpen, setStep, currentRequestId,setLoading,onError }) => {
    const { 
            accessCodesGenerated,
            ppidTitle,
            setToast,
            translateHTML: tHTML
        } = useContext(AppContext);
    const [email, setEmail] = useState('');
    const [emailError, setEmailError] = useState('');
    const [isEmailValid, setIsEmailValid] = useState(false);
    
    // Email validation regex pattern - more strict to prevent consecutive dots
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9]+(?:\.[a-zA-Z0-9]+)*\.[a-zA-Z]{2,}$/;

    if (!isOpen) return null;
    const encodeHTML = (str) =>  new DOMParser().parseFromString(str, "text/html").documentElement.textContent;

    const toastMessage = ({ title, msg, status }) => {
        setToast({
            title: tHTML(title,{unsafe: true}),
            msg: tHTML(msg, { unsafe: true}),
            styleClass: 'generate-access-toast',
            status: status,
            delay: 8000,
            autoHide: true,
            toastImg: `${process.env.PUBLIC_URL}/images/${status === "success" ? "success-green-outline.svg" : "error-red-outline.svg"}`,
            show: true,
        });
    };

    const handleDownload = () => {
        console.log('Download triggered');
        setLoading(true);
        if (currentRequestId) {
            const subscription = downloadCode(currentRequestId).subscribe(
                (response) => {
                    setLoading(false);
                    const today = new Date();
                    const dateStr = today.toISOString().split('T')[0];
                    const blob = new Blob([response], { type: 'text/csv' });
                    const url = window.URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', `${encodeHTML(ppidTitle)}_${dateStr}.csv`); // or any other extension
                    document.body.appendChild(link);
                    link.click();
                    link.parentNode.removeChild(link);
                    toastMessage({ 
                        title:'Successfully downloaded', 
                        msg: 'Access codes have been successfully downloaded', 
                        status: 'success' 
                    });
                },
            (error) => {
                setLoading(false);
                console.log(error);
                // onError(error); 
                toastMessage({
                    title: 'Not downloaded successfully',
                    msg: 'Access codes have not been downloaded. Please try again.',
                    status: 'error'
                });
            }
            );
            return () => subscription.unsubscribe();
        }
    };


    // Email validation function
    const validateEmail = (emailValue) => {
        if (!emailValue) {
            setEmailError('Email is required');
            setIsEmailValid(false);
            return false;
        }
        
        // Check for consecutive dots
        if (emailValue.includes('..')) {
            setEmailError('Please enter a valid email address');
            setIsEmailValid(false);
            return false;
        }
        
        // Check if starts or ends with dot
        if (emailValue.startsWith('.') || emailValue.endsWith('.')) {
            setEmailError('Please enter a valid email address');
            setIsEmailValid(false);
            return false;
        }
        
        // Check for dot before @
        if (emailValue.includes('.@')) {
            setEmailError('Please enter a valid email address');
            setIsEmailValid(false);
            return false;
        }
        
        // Check for dot after @
        if (emailValue.includes('@.')) {
            setEmailError('Please enter a valid email address');
            setIsEmailValid(false);
            return false;
        }
        
        // Main regex validation
        if (!emailRegex.test(emailValue)) {
            setEmailError('Please enter a valid email address');
            setIsEmailValid(false);
            return false;
        }
        
        setEmailError('');
        setIsEmailValid(true);
        return true;
    };

    // Handle email input change with validation
    const handleEmailChange = (e) => {
        const value = e.target.value;
        setEmail(value);
        
        // Clear error if user starts typing
        if (emailError && value) {
            setEmailError('');
        }
        
        // Validate on blur or when email looks complete
        if (value && (value.includes('@') && value.includes('.'))) {
            validateEmail(value);
        }
    };

    // Handle email blur for validation
    const handleEmailBlur = () => {
        if (email) {
            validateEmail(email);
        }
    };

    const handleEmail = () => {
        if (validateEmail(email)) {
            console.log('Email triggered with valid email:', email);
            // Add your email sending logic here
            let emailRecipients = [email];
            const payload = {
                "requestId": currentRequestId,
                "emailRecipients": emailRecipients
            };


                setLoading(true);

                const subscription = emailCode(payload).subscribe(
                  (response) => {
                    console.log(response);
                    setLoading(false);
                    toastMessage({
                        title:'Successfully emailed',
                        msg: 'Access codes have been successfully emailed',
                        status: 'success'
                    });
                  },
                  (error) => {
                    // onError(error);
                    setLoading(false);
                    console.log(error);
                    toastMessage({ 
                        title:'Not emailed successfully',
                        msg: 'Access codes have not been emailed. Please try again.', 
                        status: 'error' 
                    });
                  }
                );
            
                return () => subscription.unsubscribe();
        }
    };

    return (
        <div className="step-three-component">
            <div className="export-section">
                <h3 className="export-title">Export codes</h3>
                <p className="export-instruction">
                    Access codes are generating. Large orders may take a few minutes to generate before they are available to download. Once downloaded, codes will be valid for 3 years.
                </p>

                <button className="download-btn" onClick={handleDownload}>
                    <span>Download access codes</span>
                    <img src={`${process.env.PUBLIC_URL}/images/icon_download.svg`} alt="Download" />
                </button>

                <div className="email-section">
                    <p className="email-label">Enter email address to send the codes to</p>
                </div>
                <div className="email-input-group">
                     {emailError && (
                        <div className="email-error-message">
                            {emailError}
                        </div>
                    )}
                    <div className="email-input-wrapper">
                    <input
                        type="email"
                        placeholder="Enter email address"
                        value={email}
                        onChange={handleEmailChange}
                        onBlur={handleEmailBlur}
                        className={`email-input ${emailError ? 'error' : ''} ${isEmailValid ? '' : ''}`}
                    />
                    {!emailError && email && <img className="correct-icon" src={`${process.env.PUBLIC_URL}/images/correct-black.svg`} alt="correct" />}
                    {emailError && email && <img className="wrong-icon" onClick={() => setEmail("")} src={`${process.env.PUBLIC_URL}/images/wrong-icon.svg`} alt="correct" />}
                   </div>
                </div>

                <div>
                    <button
                        className="email-btn"
                        onClick={handleEmail}
                        disabled={!email || !isEmailValid || emailError}
                    >
                         <span>Email codes</span>
                          <div className="email-icon-container">
                        <img
                            src={`${process.env.PUBLIC_URL}/images/icon.svg`}
                            alt="Email icon"
                            className="
                            email-icon"
                        />
                        </div>
                    </button>
                </div>
                <div className="generate-another">
                    <button className="generate-link" onClick={() => setStep(1)}>
                        Generate another set of codes
                    </button>
                </div>
            </div>
        </div>
    );
};

export default StepThreeComponent;
